export const operationActive = (state) => {
  return state.modalForm.operationActive
}

export const operationSuccessful = (state) => {
  return state.modalForm.operationSuccessful
}

export const isVisible = (state) => {
  return state.modalForm.isVisible
}
